import type { LegalContent } from "./types";

export const termsZh: LegalContent = {
  seo: {
    title: "用户协议 - Luxoria",
    description: "管理你使用 Luxoria HDR 转换应用的条款。"
  },
  tag: "法律",
  title: "用户协议",
  lastUpdated: "最后更新：2026 年 6 月 8 日",
  sections: [
    {
      heading: "1. 接受条款",
      body: "下载、安装或使用 Luxoria 即表示你同意本用户协议。如果你不同意，请不要使用本应用。"
    },
    {
      heading: "2. Luxoria 的使用",
      body: "Luxoria 作为将 SDR 照片和视频转换为适合 HDR 显示的输出的工具提供。你可将其用于合法的个人与专业媒体转换。"
    },
    {
      heading: "3. 用户内容",
      body: "你需对选择用于转换的照片和视频负责。你必须拥有处理这些素材所需的相应权利。"
    },
    {
      heading: "4. HDR 转换结果",
      body: "HDR 转换结果会因源素材、设备、系统版本、显示屏和查看应用而有所不同。Luxoria 不保证所有文件或设备上得到完全一致的结果。"
    },
    {
      heading: "5. 兼容性与可用性",
      body: "功能和输出格式取决于你的平台及其 HDR 能力。部分功能可能并非在所有设备或系统版本上可用。"
    },
    {
      heading: "6. 禁止用途",
      body: "你不得使用 Luxoria 侵犯版权、侵害他人权利，或用于任何非法或不当目的。"
    },
    {
      heading: "7. 知识产权",
      body: "Luxoria 及其设计、品牌和软件均归 Axqora 所有，并受适用的知识产权法律保护。本协议不授予你对应用的所有权。"
    },
    {
      heading: "8. 免责声明",
      body: "Luxoria 按“现状”提供，不附带任何形式的保证。我们不保证应用不会中断、没有错误，或转换结果满足所有预期。"
    },
    {
      heading: "9. 责任限制",
      body: "在法律允许的范围内，Axqora 不对因使用 Luxoria 而产生的任何间接、附带或后果性损害负责，包括素材或数据丢失。"
    },
    {
      heading: "10. 条款变更",
      body: "随着应用的发展，我们可能会更新本用户协议。发生重大变更时，我们会更新上方显示的日期。继续使用 Luxoria 即表示接受更新后的条款。"
    },
    {
      heading: "11. 联系我们",
      body: "如对本用户协议有疑问，请通过 axqora@gmail.com 联系我们。"
    }
  ],
  contact: {
    title: "关于条款的疑问？",
    body: "请发送邮件至 axqora@gmail.com，我们会尽快回复。"
  }
};
